import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    PeopleIqFilterSettingsUpdateInput,
    UpdatePeopleIqFilterSettings as UpdatePeopleIqFilterSettingsMutation,
    UpdatePeopleIqFilterSettingsVariables as UpdatePeopleIqFilterSettingsMutationVariables,
} from 'nutshell-graphql-types';

import UPDATE_PEOPLE_IQ_FILTER_SETTINGS from '../mutations/update-people-iq-filter-settings.graphql';
import GET_PEOPLE_IQ_FILTER_SETTINGS from '../queries/get-people-iq-filter-settings.graphql';

export function useUpdatePeopleIqFilterSettings(): {
    updatePeopleIqFilterSettings: (input: PeopleIqFilterSettingsUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updatePeopleIqFilterSettings, {loading, error}] = useMutation<
        UpdatePeopleIqFilterSettingsMutation,
        UpdatePeopleIqFilterSettingsMutationVariables
    >(UPDATE_PEOPLE_IQ_FILTER_SETTINGS);

    return {
        updatePeopleIqFilterSettings: (input: PeopleIqFilterSettingsUpdateInput) =>
            updatePeopleIqFilterSettings({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const updatedSettings =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.peopleIqFilterSettingsUpdate;

                    if (updatedSettings) {
                        proxy.writeQuery({
                            query: GET_PEOPLE_IQ_FILTER_SETTINGS,
                            variables: {},
                            data: {
                                peopleIqFilterSettings: updatedSettings,
                            },
                        });
                    }
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
